import React from "react";
import { P_Props } from "./CountryForm.type";
import {SimpleModalHeader, Loading, ImageUpload } from "../../../../components";
import { FormUtil, FormUIUtil, loadCallback } from "../../../../../utils";
import { Form, Field } from "react-final-form";
import { Grid, Select, FormControl } from "@material-ui/core";
import { COUNTRY } from "../../../../../constants";

const CountryFormPresenter: React.FC<P_Props> = (props) => {
  let submit: any;

  return (
    <div className="country-form">
      <SimpleModalHeader
        title="Create new country"
        onClose={() => {
          props.onCancel();
        }}
      />
      <div className="country-form__divide">
        <div className="country-form__container">
          <div className="country-form__box">
            {props.loading && <Loading />}
            {!props.loading && (
              <Form
                initialValuesEqual={() => true}
                onSubmit={async (values, form) => {
                  props.onSubmit(values);
                }}
                render={({ handleSubmit, form, pristine }) => {
                  submit = handleSubmit;

                  return (
                    <form onSubmit={handleSubmit}>
                      <Grid container spacing={2}>
                        <Grid item xs={12}>
                          <Field name="name" validate={FormUtil.Rule.required("This is required field")}>
                            {({ input, meta, ...rest }) => {
                              return FormUIUtil.renderFormItem(
                                "Country",
                                <FormControl
                                  style={{ width: "100%" }}
                                  variant="outlined"
                                  className="country-form__select"
                                >
                                  <Select
                                    {...input}
                                    {...rest}
                                    native
                                    value={input.value}
                                    onChange={(e) => {
                                      input.onChange(e.target.value);
                                    }}
                                    error={meta.error && meta.touched}
                                  >
                                    <option value="">Select...</option>
                                    {COUNTRY.map((country, index) => (
                                      <option key={index} value={country.countryName}>{country.countryName}</option>
                                    ))}
                                  </Select>
                                </FormControl>
                              );
                            }}
                          </Field>
                        </Grid>
                        <Grid item xs={12} lg={4}>
                          {FormUIUtil.renderFormItem(
                            "Country Icon",
                            <>
                              <ImageUpload
                                className="country-form__avatar"
                                fileList={props.countryPictures}
                                max={1}
                                onChange={props.onUploadCountryIcon}
                                onDelete={props.onRemoveCountryIcon}
                                config={{ uploadModal: true }}
                              />
                            </>
                          )}
                        </Grid>
                      </Grid>
                    </form>
                  );
                }}
              />
            )}
          </div>
        </div>
      </div>

      <div className="country-form__footer">
        <button
          type="submit"
          className="btn save"
          onClick={(e) => {
            loadCallback(submit, e);
          }}
        >
          Create
          </button>
      </div>
    </div>
  );
};

export default CountryFormPresenter;
